import React, { useEffect, useRef, useState } from 'react';
import './rangeSlider.style.scss';
import { __RangeSliderProps, __RangeSliderRef } from './rangeSlider.interface';
import Slider from 'react-rangeslider';
import { Direction, ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPRangeSliderRef extends __RangeSliderRef {}

const SLPRangeSlider: React.ForwardRefRenderFunction<
    __RangeSliderRef,
    ConnectedProps<typeof connector> & __RangeSliderProps
> = (props: ConnectedProps<typeof connector> & __RangeSliderProps, ref) => {
    React.useImperativeHandle(ref, () => ({
        getValue: () => immediateValue.current,
        setError: (text) => {
            setError(text);
        },
    }));
    const range: number[] = [];
    const labelRef = useRef<HTMLLabelElement>(null);
    props.min && props.max
        ? range.push(props.min, props.max)
        : props.min
        ? range.push(props.min, 100)
        : props.max
        ? range.push(0, props.max)
        : range.push(0, 100);
    const [value, setValue] = useState<number>(props.defaultValue ? props.defaultValue : range[0]);
    const immediateValue = useRef<number>(value);
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    useEffect(() => {
        if (props.defaultValue !== undefined) {
            immediateValue.current = props.defaultValue;
            setValue(immediateValue.current);
        }
    }, [props.defaultValue]);

    const changeHandler = (e: number) => {
        setError(undefined);
        immediateValue.current = e;
        setValue(immediateValue.current);
        if (props.onChange) props.onChange(e);
    };

    return (
        <div className={`ucheck-SLP-range-slider ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}>
            <span className="d-flex">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </span>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <Slider
                reverse={props.dir === TextDirection.rtl && props.direction === Direction.rtl}
                step={props.step}
                max={props.max ? props.max : range[1]}
                min={props.min ? props.min : range[0]}
                onChange={(e) => changeHandler(e)}
                value={value}
            />
            <div className="slider-titles">
                <p className="end">{props.endTitle}</p>
                <p className="middle">{props.middleTitle}</p>
                <p className="start">{props.startTitle}</p>
            </div>
            {error && <p className="slider-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
});
const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPRangeSlider));
